module.exports = __webpack_public_path__ + "static/media/samsung.58da3029.png";